import React from "react";
import "./feedback.css";
import { Link } from "react-router-dom";
import { path, usePage } from "@/hooks";

export function Notice({ children, error = false }: { children: React.ReactNode; error?: boolean }) {
    return <div className={`v2-notice${error ? " v2-notice--error" : ""}`} role={error ? "alert" : "status"} aria-live={error ? "assertive" : "polite"}>{children}</div>;
}

export function LoadingState() {
    const { t } = usePage();
    return <div className="v2-loading" role="status"><span className="v2-spinner" aria-hidden="true" />{t("pages.loading")}</div>;
}

export function SignInRequired() {
    const { locale, t } = usePage();
    return <Notice><p>{t("pages.signInRequired")}</p><Link className="v2-button" to={path(locale, "/sign-in")}>{t("pages.signIn")}</Link></Notice>;
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: React.ReactNode }) {
    return <div className="v2-empty-state">
        <span className="v2-empty-state__mark" aria-hidden="true">•</span>
        <div><strong>{title}</strong><p>{description}</p></div>
        {action ? <div className="v2-empty-state__action">{action}</div> : null}
    </div>;
}

export function PendingButton({ pending, children, className = "v2-button", ...props }: React.ButtonHTMLAttributes<HTMLButtonElement> & { pending?: boolean }) {
    const { t } = usePage();
    return <button {...props} className={className} disabled={Boolean(props.disabled || pending)} aria-busy={pending || undefined}>
        {pending ? <><span className="v2-spinner v2-spinner--button" aria-hidden="true" />{t("pages.loading")}</> : children}
    </button>;
}
